import { QuizCategory } from '@/models/Quiz';
import { NotificationDescriptor, NotificationScope } from '@/modules/notifications/models/NotificationDescriptor';
import { oneOffStatementsConfig } from '@/modules/Statements/services/oneOffStatements';

/**
 * Registry of contextual "fixes & news" notifications (see field docs in NotificationDescriptor).
 * To add one: give it a stable `id`, a `scope`, and copy via LAZY i18n getters
 * (`() => I18NGetter().X`, never eager). Shown once per user. Example:
 *
 *   { id: 'bik-redesign-2026-06', scope: NotificationScope.ROUTE,
 *     routeNames: [Routes.CLIENT.BIK], tenants: ['LENDI_PL'], audience: isExpert,
 *     title: () => I18NGetter().X.TITLE, description: () => I18NGetter().X.DESC,
 *     trueText: () => I18NGetter().X.GOT_IT }
 */
export const NOTIFICATIONS: NotificationDescriptor[] = [
  // Zapowiedź dobrowolnej akredytacji UniCredit (oświadczenie jednokrotne).
  // TODO: przenieść copy do I18NGetter().usePlatformNotifications i odpalić `pnpm run sl-sync`.
  // Tenant to wyłącznie LENDI_PL, więc do tego czasu literalne PL nie psuje pozostałych języków.
  {
    id: 'unicredit-accreditation-2026-08',
    scope: NotificationScope.GLOBAL,
    tenants: ['LENDI_PL',],
    // Dymek pokazujemy tylko tym, którzy w ogóle zobaczą kafel oświadczenia (AC#3).
    audience: (user) => oneOffStatementsConfig[QuizCategory.UNI_CREDIT].isAvailable(user),
    anchorSelector: '.DASHBOARD-ACCREDITATION_PANEL',
    anchorPlacement: 'right',
    title: () => '<p class="mb-1"><b>Nowość! Akredytacja UniCredit</b></p>',
    description: () => '<p class="mb-0">W zakładce Akredytacja → Oświadczenia czeka na Ciebie dobrowolna akredytacja UniCredit. Po jej potwierdzeniu zaoferujesz klientom produkty UniCredit.</p>',
    trueText: () => 'Rozumiem',
  },
];
